import { render, staticRenderFns } from "./AddDocumentDialog.vue?vue&type=template&id=f655e8fc&scoped=true&lang=pug&"
import script from "./AddDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./AddDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f655e8fc",
  null
  
)

export default component.exports